import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PATHS from "../../../Routes/paths";
import { Popover, PopoverTrigger, PopoverContent, PopoverBody, PopoverFooter, PopoverCloseButton, Button, IconButton, } from "@chakra-ui/react";
import { NotifList } from "../../Molecules";

import { BellIcon, DashboardIcon, AnalyticsIcon, DealerIcon, OrdersIcon, InventoryIcon, SettingsIcon, BellAlertIcon, LeaseIcon, OrderManagementIcon, InstallationVideoIcon, DealerManagement, CloseIcon, StatisticsIcon, AlertsIcon, RideIcon, VehicleActivity, MultipleUsers } from "../../../Assets/images/svgs";
import "./styles.css";
import { AuthContext, StoreContext } from "../../../Library/contexts";
import { DRAWER_ACCESS_CODES, MAX_RESPONSIVE_BREAKPOINT_WIDTH, SELLER_DES, SUBDEALERS_DES } from "../../../Library/constants";

let DESIGNATION = +window.localStorage.getItem("des");

const routes = {
  [DRAWER_ACCESS_CODES.DASHBOARD]: {
    icon: <DashboardIcon />,   title: "Dashboard",            to: PATHS.DASHBOARD
  },
  [DRAWER_ACCESS_CODES.ANALYTICS]: {
    icon: <AnalyticsIcon />,   title: "Analytics",            to: PATHS.ANALYTICS
  },
  [DRAWER_ACCESS_CODES.DEALER]: {
    icon: <DealerIcon />,      title: "Dealer Management",    to: PATHS.DEALER
  },
  [DRAWER_ACCESS_CODES.ORDERS]: {
    icon: <OrdersIcon />,      title: "Orders",               to: PATHS.ORDERS
  },
  [DRAWER_ACCESS_CODES.INVENTORY]: {
    icon: <InventoryIcon />,   title: "Inventory Management", to: PATHS.INVENTORY
  },
  [DRAWER_ACCESS_CODES.LEASE]: {
    icon: <LeaseIcon />,       title: "Lease",                to: PATHS.LEASE
  },
  [DRAWER_ACCESS_CODES.SETTINGS]: {
    icon: <SettingsIcon />,    title: "Settings",             to: PATHS.SETTINGS
  },
  [DRAWER_ACCESS_CODES.DEALERS_OVERVIEW]: {
    icon: <DashboardIcon />,   title: "Dashboard",            to: PATHS.DEALERS_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.ORDERS_OVERVIEW]: {
    icon: <OrderManagementIcon />,   title: (DESIGNATION === SUBDEALERS_DES ? "Manage Shipment" : "Order Management"),    to: PATHS.ORDERS_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.INVENTORY_OVERVIEW]: {
    icon: <InventoryIcon />,   title: "Inventory Management",    to: PATHS.INVENTORY_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.INSTALLATION_VIDEO]: {
    icon: <InstallationVideoIcon />,   title: "Installation Videos",    to: PATHS.INSTALLATION_VIDEO
  },
  [DRAWER_ACCESS_CODES.DEALER_MANAGEMENT]: {
    icon: <DealerManagement />,   title: "Dealer Management",    to: PATHS.SHOW_DEALERS,
  },
  [DRAWER_ACCESS_CODES.SHIPMENT_OVERVIEW]: {
    icon: <OrderManagementIcon />,   title: "Manage Shipments",    to: PATHS.SHIPMENT_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.LIVE_TRACKING]: {
    icon: <DashboardIcon />,   title: "Live Tracking",    to: PATHS.LIVE_TRACKING
  },
  [DRAWER_ACCESS_CODES.ALL_VEHICLE_STATS]: {
    icon: <StatisticsIcon />,   title: "Statistics",    to: PATHS.ALL_VEHICLE_STATS
  },
  [DRAWER_ACCESS_CODES.SET_ALERTS]: {
    icon: <AlertsIcon />,    title: "Set Alerts",     to: PATHS.SET_ALERTS,
  },
  [DRAWER_ACCESS_CODES.ROUTES]: {
    icon: <RideIcon />,      title: "Routes",     to: PATHS.VIEW_ROUTES,
  },
  [DRAWER_ACCESS_CODES.VEHICLE_ACTIVITY]: {
    icon: <VehicleActivity />,  title: "Vehicle Activity",   to: PATHS.VEHICLE_ACTIVITY,
  },
  [DRAWER_ACCESS_CODES.SUB_USERS]: {
    icon: <MultipleUsers />,  title: "Subusers",      to: PATHS.SUB_USERS,
  },
};

const links = {
    top: [
      routes[DRAWER_ACCESS_CODES.ANALYTICS],
      routes[DRAWER_ACCESS_CODES.INVENTORY],
      routes[DRAWER_ACCESS_CODES.LEASE],
    ],
    bottom: [ routes[DRAWER_ACCESS_CODES.SETTINGS] ],
};


const getSelectedTab = ({ pathname }) => {
  let index = null;

  index = links.top.findIndex((link) => pathname.startsWith(link.to));
  if (index > -1) {
    return { position: "top", index: index };
  }

  if (links.bottom) {
    index = links.bottom.findIndex((link) => pathname.startsWith(link.to));
    if (index > -1) {
      return { position: "bottom", index: index };
    }
  }

  return { position: "notifications", index: index };
};

const DrawerComponent = ({ showDrawer, hideDrawer, codes }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { assets } = useContext(AuthContext);

  const [ selected, setSelected ] = useState(getSelectedTab(location));
  const [ isMobileView ] = useState(window.innerWidth < MAX_RESPONSIVE_BREAKPOINT_WIDTH);

  if (codes && codes.length) {
    let DRAWER_TOP_LINKS = [];

    let isSeller = DESIGNATION === SELLER_DES;
    codes.forEach(code => {
      if (isSeller && code === DRAWER_ACCESS_CODES.ORDERS_OVERVIEW) return;
      if (!isSeller && code === DRAWER_ACCESS_CODES.SHIPMENT_OVERVIEW) return;

      DRAWER_TOP_LINKS.push(routes[code]);
    });

    if (DRAWER_TOP_LINKS.length) {
      links.top = DRAWER_TOP_LINKS;
    }
  };

  useEffect(() => {
    setSelected(getSelectedTab(location));
  }, [ location ]);

  const getPosition = () => {
    const { position, index } = selected;

    if (position === "top") {
      const PADDING = 52;
      return { transform: `translateY(calc(${100 * index}% + ${PADDING}px))` };
    }
    if (position === "bottom") {
      const PADDING = 156;
      return { transform: `translateY(calc(100vh - (${(100 * index)}% + ${PADDING}px)))` };
    }

    return { transform: `translate(245.5px, -30px)`, height: 40, width: 40, borderRadius: "50%", padding: 0 };
  };

  const renderLink = (position, { icon, title, to }, index) => {
    const style = { transform: position === "top" ? `translateY(calc(100% * ${index}))` : `translateY(calc(-100% * ${index}))` };
    let className = "drawer-link drawer-item ";
    if (position === "bottom") className += "drawer-end-link ";

    if (position === selected.position && index === selected.index) className += "drawer-active-link";

    return (
      <Link key={index} style={style} className={className} to={to} onClick={() => hideDrawer()}>
        {icon}
        {title}
      </Link>
    )
  };

  return (
    <div className={`drawer-main ${showDrawer ? "show-drawer" : "hide-drawer"}`}>
      <header className="drawer-header">
        <div className="drawer-header-brand">
          {isMobileView ? <CloseIcon onClick={() => hideDrawer()} /> : <img alt="logo" src={assets.assetUrl + "/" + assets.logo} />}
        </div>
        <Notifications active={selected.position === "notifications"} navigate={() => navigate(PATHS.NOTIFICATIONS)} />
      </header>

      <div
        style={getPosition()}
        className="drawer-active drawer-item"
      />

      <main position="relative">

        {Object.keys(links).map((position) => {
          return links[position].map((...e) => renderLink(position, ...e));
        })}

      </main>

    </div>
  );
};

const Notifications = ({ active, navigate }) => {
  const { notifications } = useContext(StoreContext);
  const [ isOpen, setIsOpen ] = useState(false);

  const onOpen = () => {
    if (active) return;
    setIsOpen(true);
  }
  const onClose = () => setIsOpen(false);

  const handleAll = () => {
    onClose();
    navigate();
  };

  let Icon = (!active && notifications && notifications.unreadCount) > 0 ? BellAlertIcon : BellIcon;

  return (
    <div>
      <Popover placement="right" isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
        <PopoverTrigger>
          <IconButton
            icon={<Icon className={active ? "notif-active" : ""} />}
            variant="ghost"
            colorScheme="blackAlpha"
            rounded="full"
            zIndex={5}
            className="bell-icon"
          />
        </PopoverTrigger>

        <PopoverContent className="notif-container">
          <PopoverCloseButton rounded="full" />

          <PopoverBody>
            <NotifList />
          </PopoverBody>

          <PopoverFooter className="notif-footer">
            <Button colorScheme="cyan" variant="link" onClick={handleAll}>
              View All
            </Button>
          </PopoverFooter>
        </PopoverContent>
      </Popover>

      {isOpen && <div className="panel-overlay" />}
    </div>
  );
};

export default DrawerComponent;
